@if (context$ | async; as _context) {
  @if (_context === SiteContextType.CURRENCY && (hasItens(_context) | async)) {
    <button class="btn-link" (click)="openModalCurrency()" [title]="'siteContext.' + _context.toLowerCase() + '.label' | cxTranslate">
      <span class="material-symbols-outlined"> currency_exchange </span>
    </button>
  }
  @if (_context === SiteContextType.LANGUAGE && (hasItens(_context) | async)) {
    <button class="btn-link" (click)="openModalLanguage()" [title]="'siteContext.' + _context.toLowerCase() + '.label' | cxTranslate">
      <span class="material-symbols-outlined"> translate </span>
    </button>
  }
}
